import { render, staticRenderFns } from "./ThePersonalOrdersTable.vue?vue&type=template&id=03c9823a&"
import script from "./ThePersonalOrdersTable.vue?vue&type=script&lang=js&"
export * from "./ThePersonalOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalOrdersTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports